__turbopack_context__.v({
  "bar": "RouteTopLoader-module-scss-module__rf4-fW__bar",
  "root": "RouteTopLoader-module-scss-module__rf4-fW__root",
  "visible": "RouteTopLoader-module-scss-module__rf4-fW__visible",
});
